import styled, { css } from "styled-components";

const SideNavTopSection = styled.div`
    position: relative;
    padding-bottom: 3.2rem;
    width: 100%;

    &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 3.2rem;
        right: 1rem;
        background-color: ${props => props.theme.mintGreen};
        height: 0.2rem;
        width: 76%;
        border-radius: 1rem;
        transition: all 0.3s ease-in-out;

        ${props =>
            props.business &&
            css`
                background-color: ${props.theme.atlanticBlue};
            `}
			
		${props =>
			props.collapsed && css`
				width: 60%;
				left: 2.4rem;
		`}
		
    }

    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        padding: 3.2rem;
    }
`;

export { SideNavTopSection };
